const { createAction } = require('../helpers')
const {
  GET_COUPON_LIST,
  GET_COUPON_LIST_SUCCESS,
  GET_COUPON_LIST_ERROR,
  GET_COUPON_LIST_RESET,

  GET_COUPON,
  GET_COUPON_SUCCESS,
  GET_COUPON_ERROR,
  GET_COUPON_RESET,

  CREATE_COUPON,
  CREATE_COUPON_SUCCESS,
  CREATE_COUPON_ERROR,
  CREATE_COUPON_RESET,

  UPDATE_COUPON,
  UPDATE_COUPON_SUCCESS,
  UPDATE_COUPON_ERROR,
  UPDATE_COUPON_RESET,

  DELETE_COUPON,
  DELETE_COUPON_SUCCESS,
  DELETE_COUPON_ERROR,
  DELETE_COUPON_RESET,

  POST_APPLY_COUPON,
  POST_APPLY_COUPON_SUCCESS,
  POST_APPLY_COUPON_ERROR,
  POST_APPLY_COUPON_RESET,
} = require('./constants')

const getCouponList = ({ skip, take, search }) => createAction(GET_COUPON_LIST, { skip, take, search })
const getCouponListSuccess = data => createAction(GET_COUPON_LIST_SUCCESS, { data })
const getCouponListError = error => createAction(GET_COUPON_LIST_ERROR, { error })
const getCouponListReset = () => createAction(GET_COUPON_LIST_RESET)

const getCoupon = id => createAction(GET_COUPON, { id })
const getCouponSuccess = data => createAction(GET_COUPON_SUCCESS, { data })
const getCouponError = error => createAction(GET_COUPON_ERROR, { error })
const getCouponReset = () => createAction(GET_COUPON_RESET)

const createCoupon = couponData => createAction(CREATE_COUPON, { couponData })
const createCouponSuccess = data => createAction(CREATE_COUPON_SUCCESS, { data })
const createCouponError = error => createAction(CREATE_COUPON_ERROR, { error })
const createCouponReset = () => createAction(CREATE_COUPON_RESET)

const updateCoupon = ({ id, couponData }) => createAction(UPDATE_COUPON, { id, couponData })
const updateCouponSuccess = data => createAction(UPDATE_COUPON_SUCCESS, { data })
const updateCouponError = error => createAction(UPDATE_COUPON_ERROR, { error })
const updateCouponReset = () => createAction(UPDATE_COUPON_RESET)

const deleteCoupon = ({ id }) => createAction(DELETE_COUPON, { id })
const deleteCouponSuccess = data => createAction(DELETE_COUPON_SUCCESS, { data })
const deleteCouponError = error => createAction(DELETE_COUPON_ERROR, { error })
const deleteCouponReset = () => createAction(DELETE_COUPON_RESET)

const postApplyCoupon = data => createAction(POST_APPLY_COUPON, { data })
const postApplyCouponSuccess = data => createAction(POST_APPLY_COUPON_SUCCESS, { data })
const postApplyCouponError = error => createAction(POST_APPLY_COUPON_ERROR, { error })
const postApplyCouponReset = () => createAction(POST_APPLY_COUPON_RESET)

module.exports = {
  getCouponList,
  getCouponListSuccess,
  getCouponListError,
  getCouponListReset,
  getCoupon,
  getCouponSuccess,
  getCouponError,
  getCouponReset,
  createCoupon,
  createCouponSuccess,
  createCouponError,
  createCouponReset,
  updateCoupon,
  updateCouponSuccess,
  updateCouponError,
  updateCouponReset,
  deleteCoupon,
  deleteCouponSuccess,
  deleteCouponError,
  deleteCouponReset,
  postApplyCoupon,
  postApplyCouponSuccess,
  postApplyCouponError,
  postApplyCouponReset,
}
